import { Box, Typography, IconButton } from "@mui/material";
import ProductDetail from "./ProductDetail";
import ProductSection from "./ProductsSection";
import { useAuth } from "../../context/AuthContext";
import { useEffect, useState } from "react";
import productService from "../../service/productService";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useProductLimit } from "../../context/ProductFilterContext";

export default function TopSellersSection({
  title,
  categories,
  image,
  onSelectProduct,
  selectedProduct,
  onBack,

  showControls,
  onPrev,
  onNext,
  isFirst,
  isLast,
}) {
  const { user } = useAuth();
  const limit = useProductLimit();

  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  useEffect(() => {
    productService
      .getProductsPaginated(categories, "asc", limit, page, "", "")
      .then((data) => {
        setProducts(data.products || []);
        setPages(data.pages > 0 ? data.pages : 1);
      })
      .catch((err) => console.error("Error fetching seasonal products:", err));
  }, [categories, page, limit]);

  if (selectedProduct) {
    return <ProductDetail product={selectedProduct} onBack={onBack} />;
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 4,
          gap: 2,
          p: 2,
          bgcolor: "primary.main",
          color: "primary.contrastText",
          borderRadius: 3,
          border: "1px solid rgba(255,255,255,.14)",
          boxShadow: "0 18px 44px rgba(36,74,56,.18)",
        }}
      >
        {showControls ? (
          <IconButton
            onClick={onPrev}
            disabled={isFirst}
            sx={{
              bgcolor: "rgba(255,255,255,.12)",
              color: "white",
              boxShadow: 1,
              "&:disabled": { opacity: 0.3 },
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
        ) : (
          <Box sx={{ width: 40 }} />
        )}

        <Typography
          variant="h5"
          fontWeight={700}
          sx={{
            textAlign: "center",
            flex: 1,
            letterSpacing: "0.3px",
            color: "inherit",
          }}
        >
          {title}
        </Typography>

        {showControls ? (
          <IconButton
            onClick={onNext}
            disabled={isLast}
            sx={{
              bgcolor: "rgba(255,255,255,.12)",
              color: "white",
              boxShadow: 2,
              "&:disabled": { opacity: 0.3 },
            }}
          >
            <ChevronRightIcon />
          </IconButton>
        ) : (
          <Box sx={{ width: 40 }} />
        )}
      </Box>

      <ProductSection
        products={products}
        user={user}
        onSelectProduct={onSelectProduct}
        onSetPage={setPage}
        page={page}
        pages={pages}
      />
    </>
  );
}
